var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenTickAnimatedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#27AE60",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 29,
    fill: "#27AE60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6004 25.856C52.5931 26.445 52.3579 26.8746 52.0558 27.2832C49.2889 31.0253 46.5235 34.7685 43.7598 38.513C41.1664 42.0251 38.5735 45.5376 35.9812 49.0504C35.3114 49.9578 34.2392 50.2563 33.3699 49.7652C33.1866 49.6597 33.0189 49.5297 32.8716 49.3791C30.117 46.5892 27.3645 43.797 24.6143 41.0023C24.037 40.4165 23.8402 39.7248 24.1373 38.9675C24.4268 38.23 24.9907 37.7606 25.823 37.6905C26.2847 37.6512 26.745 37.7799 27.117 38.0522C29.2357 39.5473 31.3547 41.0419 33.4741 42.5363C33.8961 42.8332 34.3054 42.752 34.6751 42.307C35.263 41.5991 35.8444 40.8859 36.4282 40.1747C40.5993 35.0919 44.7708 30.0093 48.9424 24.9271C49.7424 23.9528 50.7789 23.7303 51.7133 24.3362C51.9732 24.5016 52.1893 24.7258 52.3436 24.9901C52.4979 25.2545 52.5859 25.5513 52.6004 25.856Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickAnimatedIcon);
export default __webpack_public_path__ + "static/media/GreenTickAnimatedIcon.ea330268c23353593ceeba41aec8d4ae.svg";
export { ForwardRef as ReactComponent };